import config from './config'
import { getCookie, setCookie } from './cookies'

// A page load coming back from SSO carries the token in the URL. Read once, before Auth strips it.
const tokenFromLogin = new URLSearchParams(window.location.search).get('token')

// Kept in memory as well as in the cookie. A browser that refuses the cookie would otherwise lose
// the token as soon as it leaves the URL, and Auth would send the user back to SSO forever.
let token = tokenFromLogin

export const getToken = () => token || getCookie('auth_token')

export const storeToken = value => {
  token = value
  if (getCookie('auth_token') !== value) setCookie('auth_token', value)
}

// SSO already ran for this page load: sending the user there again is how the loop starts.
export const canRedirectToLogin = () => !tokenFromLogin

// Built at call time and without the token: config is evaluated once, while the URL still has it.
export const redirectToLogin = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete('token')
  window.location.href = config.LOGIN_URL + encodeURIComponent(url.href)
}
